<a
  routerLink="/on-demand/products/{{ product.getSlug() }}"
  class="product-info"
>
  <app-image-container
    [image]="imageUrl"
    type="small-product"
  ></app-image-container>
  <div class="product-info--label color--primary-grey ms-2">
    <span
      [innerHTML]="product.label | safeContent"
      class="d-block font-5 fw-bold text-hidden-ellipsis"
    ></span>
    <span class="d-block font-6"
      >SKU: {{ product.firstSku.getDisplaySkuID() }}</span
    >
  </div>
  <div>
    <app-product-price
      [price]="product.getPrice(0)"
      [priceRange]="product.hasVariations ? product.priceVariations : null"
      [originalPrice]="product.getOriginalPrice()"
      [discount]="product.discount ? product.discount : 0"
      color="color--primary-grey"
      fontSize="font-5"
      orientation="vertical"
    ></app-product-price>
    @if (product.skus[0].packageQuantity == 1) {
      <span class="font-6 color--primary-grey">EA</span>
    }
    @if (product.skus[0].packageQuantity > 1) {
      <span class="font-6 color--primary-grey"
        >{{ product.skus[0].attr_pkg_qty }}/PK</span
      >
    }
  </div>
</a>
